import * as React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { ERequestType } from "../../../../api";
import { getDrupalRouteStr } from "../../../../utils/RequestRouteUtil";
import { DrupalColors } from "../../../DrupalColors";

export interface IIconLinkProps {
  text: string;
  requestType: ERequestType;
}

const Container = styled.div`
  display: flex;
  align-items: baseline;
  font-weight: bold;
  color: ${DrupalColors.blue} !important;
  & > a {
    margin-left: 0.5rem;
  }
`;

export const IconLink: React.FunctionComponent<IIconLinkProps> = ({ text, requestType }) => {
  const history = useHistory();
  const redirect = React.useCallback(() => {
    const route = getDrupalRouteStr(requestType);
    history.push(`${route}/0`);
  }, [history, requestType]);

  return (
    <Container>
      <i className="fas fa-chevron-circle-right" />
      <a
        onClick={(e) => {
          e.preventDefault();
          redirect();
        }}
        href="_"
      >
        <div>{text}</div>
      </a>
    </Container>
  );
};
